import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

function ParticleBg() {
  async function loadParticles(main) {
    await loadFull(main);
  }

  return (
    <Particles
      id="tsparticles"
      init={loadParticles}
      options={{
        background: {
          // "color": "#ff000010",
          image: "url('./images/intro-bg-min-min.jpg')",
          filter: "brightness(0.9)",
          position: "50% 50%",
          repeat: "no-repeat",
          size: "cover",
          height: "100vh",
          width: "100%",
        },
        particles: {
          number: {
            value: 108,
            density: {
              enable: true,
              value_area: 1183.721462448409,
            },
          },
          color: {
            value: "#ffffff",
          },
          shape: {
            type: "circle",

            stroke: {
              width: 0,
              // "color": "#000000"
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              src: "img/github.svg",
              width: 100,
              height: 100,
            },
          },
          opacity: {
            value: 0.5,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 3,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },

          line_linked: {
            enable: true,
            distance: 150,
            color: "#ffffff",
            opacity: 0.2,
            width: 0,
          },
          move: {
            enable: true,
            speed: 3,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          events: {
            onhover: {
              enable: true,
              mode: ["repulse"],
            },
            onclick: {
              enable: false,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,

        fullScreen: {
          enable: true,
          zIndex: -1,
        },
        style: {
          position: "absolute",
        },
      }}
    />
  );
}

export default ParticleBg;
